import Vue from 'vue'

// Global components
const requireContext = require.context('./', true, /.*\.vue$/)
requireContext.keys().forEach(file => {
    const component = requireContext(file).default
    Vue.component(component.name, component)
})


// WEBPACK FOOTER //
// ./src/components/index.js